import NotFound from 'layouts/NotFound';

export default [
    {
        path: '*',
        component: NotFound,
    },
];
